import React from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider
} from '@mui/material';
import {
  NoteAdd as NewIcon,
  FolderOpen as OpenIcon,
  Save as SaveIcon,
  SaveAs as SaveAsIcon,
  FileCopy as CopyIcon,
  Download as DownloadIcon,
  Print as PrintIcon,
  DriveFileRenameOutline as RenameIcon
} from '@mui/icons-material';

export const showFileMenu = ({
  anchorEl,
  onClose,
  handlers = {},
  options = {
    showNew: true,
    showOpen: true,
    showCopy: true,
    showRename: true
  }
}) => {
  const menuItems = [
    ...(options.showNew ? [{
      icon: <NewIcon />,
      text: 'New',
      onClick: handlers.onNew,
      divider: false
    }] : []),
    ...(options.showOpen ? [{
      icon: <OpenIcon />,
      text: 'Open',
      onClick: handlers.onOpen,
      divider: true
    }] : []),
    {
      icon: <SaveIcon />,
      text: 'Save',
      onClick: handlers.onSave,
      divider: false
    },
    {
      icon: <SaveAsIcon />,
      text: 'Save As...',
      onClick: handlers.onSaveAs,
      divider: false
    },
    ...(options.showCopy ? [{
      icon: <CopyIcon />,
      text: 'Make a copy',
      onClick: handlers.onCopy,
      divider: true
    }] : []),
    {
      icon: <DownloadIcon />,
      text: 'Download',
      onClick: handlers.onDownload,
      divider: false
    },
    {
      icon: <PrintIcon />,
      text: 'Print',
      onClick: handlers.onPrint,
      divider: true
    },
    ...(options.showRename ? [{
      icon: <RenameIcon />,
      text: 'Rename',
      onClick: handlers.onRename,
      divider: false
    }] : [])
  ];

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      PaperProps={{
        sx: {
          bgcolor: '#2D2D2D',
          color: 'white',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.4)',
          '& .MuiMenuItem-root': {
            px: 2,
            py: 1,
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.1)'
            }
          },
          '& .MuiListItemIcon-root': {
            color: 'inherit',
            minWidth: '36px'
          },
          '& .MuiDivider-root': {
            borderColor: 'rgba(255, 255, 255, 0.1)',
            my: 0.5
          }
        }
      }}
    >
      {menuItems.map((item, index) => (
        <React.Fragment key={item.text}>
          <MenuItem onClick={() => {
            item.onClick?.();
            onClose();
          }}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText>{item.text}</ListItemText>
          </MenuItem>
          {item.divider && <Divider />}
        </React.Fragment>
      ))}
    </Menu>
  );
}; 